"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Icon = _interopRequireDefault(require("../Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _domain = require("../../utils/domain");

var _StretchMenuLayout = require("./StretchMenuLayout.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * 多了一層menu可選的layout
 */
var SubMenu = _antd.Menu.SubMenu,
    Item = _antd.Menu.Item;

var StretchMenuLayout = function StretchMenuLayout(_ref) {
  var header = _ref.header,
      sidebar = _ref.sidebar,
      children = _ref.children,
      title = _ref.title,
      env = _ref.env,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? "localhost" : _ref$version;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShow = _useState2[0],
      setState = _useState2[1];

  var toggleSidebar = function toggleSidebar() {
    setState(!isShow);
  };

  var urlGroup = (0, _react.useMemo)(function () {
    // 跨系統連結要留在使用者當下所在的網域：
    // nani 網域的 quesion bank 走到 nani 網域的 resource library
    // oneclasse 網域的 quesion bank 走到 oneclass 網域的 resource library
    var baseDomain = (0, _domain.getBaseDomain)() || _domain.ONECLASS_DOMAIN;

    var envSuffix = env !== "release" ? "-".concat(env) : "";
    var resourceLibrary = "https://resource-library".concat(envSuffix, ".").concat(baseDomain, "/");
    var tiku = "https://question-bank".concat(envSuffix, ".").concat(baseDomain, "/");
    return {
      resourceLibrary: resourceLibrary,
      tiku: tiku
    };
  }, [env]);
  return /*#__PURE__*/_react.default.createElement(_StretchMenuLayout.UiStretchMenuLayout, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "header"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    onClick: function onClick() {
      return toggleSidebar();
    }
  }, isShow ? "close" : "menu"), header), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("mark", isShow && "active")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("stretchMenu", isShow && "active")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "linkContainer"
  }, /*#__PURE__*/_react.default.createElement(_antd.Menu, {
    defaultSelectedKeys: ["1"],
    mode: "inline"
  }, /*#__PURE__*/_react.default.createElement(Item, {
    key: "publicCode",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "grid_on"
    })
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlGroup.resourceLibrary, "publicCode?type=year")
  }, "\u5171\u7528\u4EE3\u78BC")), /*#__PURE__*/_react.default.createElement(Item, {
    key: "subject",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "domain_verification"
    })
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlGroup.resourceLibrary, "subject")
  }, "\u79D1\u76EE\u8CC7\u6599")), /*#__PURE__*/_react.default.createElement(SubMenu, {
    key: "chapter",
    title: "\u7AE0\u7BC0\u8CC7\u6599",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "list_alt"
    })
  }, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: "chapter"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlGroup.resourceLibrary, "chapter")
  }, "\u8AB2\u672C\u7AE0\u7BC0")), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    key: "all",
    disabled: true
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlGroup.resourceLibrary, "publicCode?type=year")
  }, "\u7E3D\u8907\u7FD2\u7AE0\u7BC0"))), /*#__PURE__*/_react.default.createElement(Item, {
    key: "product",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "pageview",
      type: "outLined"
    }),
    disabled: true
  }, "\u7522\u54C1\u67E5\u8A62"), /*#__PURE__*/_react.default.createElement(Item, {
    key: "tiku",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "eco",
      type: "outLined"
    })
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: urlGroup.tiku
  }, "\u984C\u5EAB")), /*#__PURE__*/_react.default.createElement(Item, {
    key: "onetube",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "video_library",
      type: "outLined"
    }),
    disabled: true
  }, "\u5F71\u97F3\u5EAB"), /*#__PURE__*/_react.default.createElement(Item, {
    key: "book",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "chrome_reader_mode",
      type: "outLined"
    }),
    disabled: true
  }, "\u96FB\u5B50\u66F8"))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "sidebar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, title), sidebar, /*#__PURE__*/_react.default.createElement("div", {
    className: "version"
  }, version)), /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "scroll"
  }, children))));
};

var _default = StretchMenuLayout;
exports.default = _default;
StretchMenuLayout.propTypes = {
  title: _propTypes.default.node,
  header: _propTypes.default.element,
  sidebar: _propTypes.default.element,
  children: _propTypes.default.node,
  env: _propTypes.default.string,
  version: _propTypes.default.string
};